import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=425f45cc&scoped=true&"
import script from "./MenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./MenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=425f45cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f45cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle,VMenu})
